import React, { useState, useEffect } from "react";

function PollForm({ activePoll, onChoiceSubmit }) {

    const [ choice, setChoice ] = useState()

    const handleSubmit = event => {
        event.preventDefault()
        onChoiceSubmit(choice)
    }

    const onRadioChanged = event => {
        setChoice(event.target.value)
    }

    const renderChoices = (pollChoices) => {
        return (
            <fieldset>
                <legend>Deine Stimme</legend>
                { pollChoices.map(e => (
                    <label key={e}>
                        <input 
                            type="radio" 
                            name="choice" 
                            value={e} 
                            onChange={onRadioChanged}
                        />
                        {e}
                    </label>
                )) }
            </fieldset>
        )
    }

    return (
        <div>
            <hgroup>
                <h1>{ activePoll.question }</h1>
                <h2>Laufende Umfrage</h2>
            </hgroup>
            <form onSubmit={handleSubmit}>
                { renderChoices(activePoll.choices) }
                <button type="submit">Stimme abgeben</button>
            </form>
        </div>
    )
}

export default PollForm;